export default {
  namespaced: true,
  state: {
    connkey: null, //URL 접속시 접속 키
    conninfo: null, //최초 접속시 키로 조회되어 오는 값.
    user: null, //인증후 user 정보가 저장됨
    isTryAuth: false, //인증을 시도 여부
    selfConfirmInfo: null, // 상담사 연결 시 본인확인 정보가 저장됨.
    //isTrySelfConfirm: false 
  },
  mutations: {
    setConnKey(state, _key) {
      //접속키를 저장함.
      state.connkey = _key;
    },
    setConnect(state, _conninfo) {
      //조회된 접속정보를 저장
      state.conninfo = _conninfo;
    },
    setAuthrize(state, _user) {
      //인증후 인증정보를 저장
      state.user = _user;
    },
    setTryAuth(state, _tryAuth) {
      //인증 시도 여부
      state.isTryAuth = _tryAuth;
    },
    setSelfConfirm(state, _selfConfirm) {
      // 본인확인 정보를 저장
      state.selfConfirmInfo = _selfConfirm;
    }
  },
  actions: {
    saveConnectKey({ commit }, _key) {
      commit("setConnKey", _key);
    },
    saveConnectInfo({ commit }, _conninfo) {
      commit("setConnect", _conninfo);
    },
    saveLogin({ commit }, _user) {
      commit("setAuthrize", _user);
    },
    saveLogout({ commit }) {
      commit("setAuthrize", null);
    },
    closeService({ commit }) {
      commit("setConnKey", null);
      commit("setConnect", null);
      commit("setAuthrize", null);
    },
    saveSelfConfirmInfo({ commit }, _selfConfirm) {
      commit("setSelfConfirm", _selfConfirm);
    },
    saveIsTryAuth({ commit }, _tryAuth) {
      commit("setTryAuth", _tryAuth);
    }
  },
  getters: {
    getConnKey(state) {
      return state.connkey;
    },
    getConnectInfo(state) {
      return state.conninfo;
    },
    getConnInfo: state => key => {
      //let _conninfo = null;
      let value = null;
      if (state.conninfo != null) {
        value = state.conninfo[key];
      }
      return value;
    },
    getUser(state) {
      return state.user;
    },
    getUserInfo: state => key => {
      let value = null;
      if (state.user != null) {
        value = state.user[key];
      }
      return value;
    },
    isAuthorize(state) {
      let value = false;
      if (state.user != null) {
        value = true;
      }
      return value;
    },
    isTryAuth(state) {
      return state.isTryAuth;
    },
    getSelfConfirmInfo(state) {
      return state.selfConfirmInfo;
    },
    getSelfIfno: state => key => {
      let value = null;
      if(state.selfConfirmInfo != null) {
        value = state.selfConfirmInfo[key];
      }
      return value;
    }
    // getSubMenuData: state => menu_id => {
    //   let submenu = null;
    //   state.menu_data.forEach(item => {
    //     if (item.MENU_ID === menu_id) {
    //       submenu = item.MENU_LIST;
    //       return;
    //     }
    //   });
    //   return submenu;
    // },
    // getPgmData(state) {
    //   if (!state.pgm_data) return null;
    //   return state.pgm_data;
    // }
  }
};
